import { logDev } from "@/lib/api";

// Adaptive quality: 720p -> 480p -> 360p based on packet loss / available bandwidth, steps back up when healthy.
const LEVELS = [
  { name: "720p", scale: 1, maxBitrate: 1_800_000 },
  { name: "480p", scale: 1.5, maxBitrate: 900_000 },
  { name: "360p", scale: 2, maxBitrate: 500_000 },
];
const POLL_MS = 3000;
const LOSS_DOWN = 0.05;
const LOSS_UP = 0.01;
const BW_DOWN = 600_000;
const GOOD_TICKS_TO_UPGRADE = 4;

export function attachBandwidthMonitor(pc, onLevelChange) {
  let level = 0;
  let goodTicks = 0;
  let prev = { sent: 0, lost: 0 };

  const apply = async (next) => {
    const sender = pc.getSenders().find((s) => s.track?.kind === "video");
    if (!sender) return;
    const params = sender.getParameters();
    if (!params.encodings?.length) params.encodings = [{}];
    params.encodings[0].scaleResolutionDownBy = LEVELS[next].scale;
    params.encodings[0].maxBitrate = LEVELS[next].maxBitrate;
    try { await sender.setParameters(params); level = next; onLevelChange?.(LEVELS[next].name); }
    catch (e) { logDev("setParameters failed", e); }
  };

  const tick = async () => {
    if (pc.connectionState !== "connected") return;
    let stats;
    try { stats = await pc.getStats(); } catch { return; }
    let sent = 0, lost = 0, bw = Infinity;
    stats.forEach((r) => {
      if (r.type === "outbound-rtp" && r.kind === "video") sent += r.packetsSent || 0;
      if (r.type === "remote-inbound-rtp" && r.kind === "video") lost += r.packetsLost || 0;
      if (r.type === "candidate-pair" && r.nominated && r.availableOutgoingBitrate) bw = r.availableOutgoingBitrate;
    });
    const dSent = sent - prev.sent, dLost = Math.max(0, lost - prev.lost);
    prev = { sent, lost };
    if (dSent < 20) return;
    const loss = dLost / (dSent + dLost);
    if ((loss > LOSS_DOWN || bw < BW_DOWN) && level < LEVELS.length - 1) { goodTicks = 0; return apply(level + 1); }
    if (loss < LOSS_UP && bw > BW_DOWN * 2 && level > 0 && ++goodTicks >= GOOD_TICKS_TO_UPGRADE) { goodTicks = 0; return apply(level - 1); }
  };

  const iv = setInterval(tick, POLL_MS);
  return () => clearInterval(iv);
}
